window.addEventListener('DOMContentLoaded', () => {

    collectionMobileCardMovementWrapper();

    function collectionMobileCardMovementWrapper(){
        const collection = document.querySelector('.collection')
        let windowScreenWidth = window.screen.width; // media device breakpoints
        const collectionProductMedia = collection.querySelector(".the-collection-product-media");
        let newProductHighlight = collection.querySelector(".new-product-highlight");
        let collectionMediaChildren = collectionProductMedia.children;

        if (windowScreenWidth<=1024){
            function autoSwipeToHalf(){

                for (let i=0; i<collectionMediaChildren.length; i++) {
                    collectionMediaChildren[i].classList.add("in-of-swipe-placement");
                    newProductHighlight?.classList.add("in-of-swipe-placement");
                    collectionMediaChildren[i].classList.remove("out-of-swipe-placement");
                    collectionMediaChildren[0].classList.remove("out-of-swipe-placement-first");
                    if( collectionMediaChildren[1] ) {
                        collectionMediaChildren[1].classList.remove("out-of-swipe-placement-second");
                    }
                    newProductHighlight?.classList.remove("out-of-swipe-placement");
                }
            }

            function autoReturn(){
                for (let i=0; i<collectionMediaChildren.length; i++) {
                    collectionMediaChildren[i].classList.remove("in-of-swipe-placement");
                    newProductHighlight?.classList.remove("in-of-swipe-placement");
                    collectionMediaChildren[i].classList.add("out-of-swipe-placement");
                    collectionMediaChildren[0].classList.add("out-of-swipe-placement-first");
                    newProductHighlight?.classList.add("out-of-swipe-placement");

                    // delay positioning second img back to default to avoid animation interruption
                    function timeoutSecondImg(){
                        if( collectionMediaChildren[1] ) {
                            collectionMediaChildren[1].classList.add("out-of-swipe-placement-second");
                        }
                    }

                    setTimeout(timeoutSecondImg, 250);
                }
            }

            // run delayed animation on load
            setTimeout(autoSwipeToHalf,200);
            setTimeout(autoReturn,1000);
        }
    }
});
